import React from 'react'
import Image from '../../../common/footer/Images/Image'

function InterviewRelatedSeriesStencil({ classes }) {
    return (
        <div>
            <div class={`edu-blog-widget-2 widget-latest-post ${classes ? classes : ""}`}>
                <div class="inner">
                    <h5 className="placeholder-glow mb--30">
                        <span className="placeholder w-50 bg-smoke"></span>
                    </h5>
                    <div class="content latest-post-list">
                        <div class="latest-post">
                            <div class="thumbnail">
                                <div className='d-block related-series-image'>
                                    <Image src="#" alt="Thumbnail" fill />
                                </div>
                            </div>
                            <div className='w-100 mt--10'>
                                <h6 className='mb--10'>
                                    <div className="price w-100 placeholder placeholder-glow bg-smoke"></div>
                                </h6>
                                <div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </div>
                        </div>

                        <div class="latest-post">
                            <div class="thumbnail">
                                <div className='d-block related-series-image'>
                                    <Image src="#" alt="Thumbnail" fill />
                                </div>
                            </div>
                            <div className='w-100 mt--10'>
                                <h6 className='mb--10'>
                                    <div className="price w-100 placeholder placeholder-glow bg-smoke"></div>
                                </h6>
                                <div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </div>
                        </div>

                        <div class="latest-post">
                            <div class="thumbnail">
                                <div className='d-block related-series-image bg-smoke'>
                                    <Image src="#" alt="Thumbnail" fill />
                                </div>
                            </div>
                            <div className='w-100 mt--10'>
                                <h6 className='mb--10'>
                                    <div className="price w-100 placeholder placeholder-glow bg-smoke"></div>
                                </h6>
                                <div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </div>
                        </div>

                        <div class="latest-post">
                            <div class="thumbnail">
                                <div className='d-block related-series-image bg-smoke'>
                                    <Image src="#" alt="Thumbnail" fill />
                                </div>
                            </div>
                            <div className='w-100 mt--10'>
                                <h6 className='mb--10'>
                                    <div className="price w-100 placeholder placeholder-glow bg-smoke"></div>
                                </h6>
                                <div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default InterviewRelatedSeriesStencil
